export default function initContact(): void {
    const $contactContainer = document.querySelectorAll('.js-block-contact');

    $contactContainer.forEach($container => {
        new Contact($container as HTMLElement);
    });
}

class Contact {
    $el: HTMLElement;
    $body: HTMLElement = document.body;
    modale: HTMLDialogElement | null = null;
    overlayDiv: HTMLDivElement | null = null;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.displayModal();
    }

    centerModalOnScreen(): void {
        this.modale?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }

    displayModal(): void {
        document.addEventListener('wpcf7mailsent', () => {
            this.modale = this.$el.querySelector(".confirm-dialog-block") as HTMLDialogElement;
            this.overlayDiv = document.querySelector('.overlay-form');
            const closeBtn = this.modale.querySelector('.close-icon');
    
            if (this.modale) {
                this.modale.show();
    
                if (!this.overlayDiv) {
                    this.overlayDiv = document.createElement("div");
                    this.overlayDiv.classList.add("overlay-form");
                    this.$body.appendChild(this.overlayDiv);
                }
                
                if (document.getElementById('block-form-dialog')) {
                    this.overlayDiv.classList.add('active');
                    this.$body.classList.add('cut-scroll');
                    this.centerModalOnScreen();


                    closeBtn?.addEventListener('click', () => this.closeModal());
                    this.overlayDiv?.addEventListener('click', () => this.closeModal());
                }
            }
        });
    }

    closeModal(): void {
        if (this.modale) {
            this.modale.close();
        }
    
        if (this.overlayDiv) {
            this.overlayDiv.classList.remove('active');
            this.overlayDiv.remove();
        }
        
        this.$body.classList.remove('cut-scroll');
    }
}

